import { render, staticRenderFns } from "./MyNeobanxPage.vue?vue&type=template&id=693cda6a&scoped=true&"
import script from "./MyNeobanxPage.vue?vue&type=script&lang=ts&"
export * from "./MyNeobanxPage.vue?vue&type=script&lang=ts&"
import style0 from "./MyNeobanxPage.vue?vue&type=style&index=0&id=693cda6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "693cda6a",
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QIcon});
